import { ConfigurePrinterPage } from '@justomx/atlas-components'
import { usePrinter } from './Printer.hook'

const PrinterPage = () => {
  const { actions } = usePrinter()

  return (
    <ConfigurePrinterPage
      title="Conectar impresora"
      onPrinterPageChange={actions.onPrinterPageChange}
      onAction={actions.goBack}
    />
  )
}

export default PrinterPage
